<template>
    <button
        type="button"
        class="fc-trigger"
        :class="{ 'is-on': open }"
        :aria-expanded="open ? 'true' : 'false'"
        :title="$t('feedback.trigger')"
        @click="toggle"
    >
        <svg class="fc-trigger__glyph" viewBox="0 0 24 24" aria-hidden="true">
            <circle cx="12" cy="18" r="2"/>
            <path d="M5.5 13.5a9 9 0 0 1 13 0" fill="none" stroke="currentColor" stroke-width="1.6"
                  stroke-linecap="round"/>
            <path d="M2.5 9.5a13.5 13.5 0 0 1 19 0" fill="none" stroke="currentColor" stroke-width="1.6"
                  stroke-linecap="round" opacity="0.55"/>
        </svg>
        <span class="fc-trigger__label">{{ $t('feedback.trigger') }}</span>
    </button>
</template>

<script>
/*
 * The button that opens the feedback console: an icon and a word in the
 * screen's bottom-right corner, on every screen a signed-in player can reach.
 * It owns nothing but the toggle.
 */
import feedbackConsole from '@/services/feedbackConsole';

export default {
    name: 'FeedbackTrigger',
    computed: {
        open() {
            return feedbackConsole.isOpen;
        },
    },
    methods: {
        toggle() {
            feedbackConsole.toggle();
        },
    },
};
</script>

<style scoped>
/* Plain furniture: an icon and a word, no plate and no glow. The console it
   opens is the holographic thing; the control that opens it is not. */
.fc-trigger {
    display: inline-flex;
    align-items: center;
    gap: 0.35rem;
    padding: 0;
    color: #d9e0e3;
    background: none;
    border: none;
    cursor: pointer;
    transition: color 0.14s ease;
}

.fc-trigger:hover,
.fc-trigger:active,
.fc-trigger.is-on {
    color: var(--game-accent, #ffd700);
}

.fc-trigger:focus-visible {
    outline: 1px solid var(--game-accent, #ffd700);
    outline-offset: 3px;
}

.fc-trigger__glyph {
    width: 0.85rem;
    height: 0.85rem;
    fill: currentColor;
    stroke: currentColor;
}

.fc-trigger__label {
    font-family: 'Orbitron', system-ui, sans-serif;
    font-size: 0.48rem;
    letter-spacing: 0.18em;
    text-transform: uppercase;
}

@media (max-width: 30rem) {
    .fc-trigger__label {
        display: none;
    }
}
</style>
